import React from 'react';
import { DishFirstFoodItemsSegmentFragment, DishFirstSegmentFilter } from 'src/gqlReactTypings.generated.d';
import { SpecialtyHero } from 'src/pages/consumer/dish-first/explore/components/PageHero/SpecialtyHero';
import { UseExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';

type IProps = {
  className?: string;
  filters: UseExploreUrl<DishFirstSegmentFilter>;
  segment?: DishFirstFoodItemsSegmentFragment;
  total?: number;
};

export const PageHero: React.FC<IProps> = ({ className, filters, segment, total }) => {
  const isSpecialtySegment = filters.segmentFilters?.length;

  return segment && isSpecialtySegment ? <SpecialtyHero className={className} segment={segment} total={total} /> : null;
};
